import { createAsyncThunk } from '@reduxjs/toolkit';
import { CLINICS } from '../../constant';
import { authFetch } from '../../Utils/authFetch';

// One clinic's full record, for the Super Admin edit form.
export const getClinicByIdApi = createAsyncThunk(
  'clinic/getById',
  async (clinicId: string, { rejectWithValue }) => {
    try {
      const res = await authFetch(
        `${CLINICS.GET_HOSPITAL_TEMPLATE_URL}?hospitalId=${encodeURIComponent(clinicId)}`,
        { method: 'GET', headers: { 'Content-Type': 'application/json' } }
      );
      const data = await res.json();
      if (!res.ok) {
        return rejectWithValue(data?.msg || 'Failed to load clinic');
      }
      const clinic = data?.data?.[0];
      if (!clinic) {
        return rejectWithValue('Clinic not found');
      }
      return clinic;
    } catch (error) {
      return rejectWithValue((error as Error)?.message || 'Failed to load clinic');
    }
  }
);
